import { IDashboard, IDashboardGroup, IWidget } from '@/pages/Dashboards/dashboards.types.ts'
import eventBus from '@/services/eventBus'

const created = (dashboard: IDashboard) => {
  eventBus.pub('dashboards.created', dashboard)
}

const updated = (dashboard: IDashboard) => {
  eventBus.pub('dashboards.updated', dashboard)
}

const deleted = (id: IDashboard['id']) => {
  eventBus.pub('dashboards.deleted', id)
}

const groupCreated = (group: IDashboardGroup) => {
  eventBus.pub('dashboards.groups.created', group)
}

const groupUpdated = (group: IDashboardGroup) => {
  eventBus.pub('dashboards.groups.updated', group)
}

const groupDeleted = (id: IDashboardGroup['id']) => {
  eventBus.pub('dashboards.groups.deleted', id)
}

const widgetCreated = (widget: IWidget) => {
  eventBus.pub('dashboards.widgets.created', widget)
}

const widgetUpdated = (widget: IWidget) => {
  eventBus.pub('dashboards.widgets.updated', widget)
}

const widgetDeleted = (id: IWidget['id']) => {
  eventBus.pub('dashboards.widgets.deleted', id)
}

const dashboardsEvents = {
  created,
  updated,
  deleted,
  widgetCreated,
  widgetUpdated,
  widgetDeleted,
  groupCreated,
  groupUpdated,
  groupDeleted,
}

export default dashboardsEvents
